<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove this contract from the accommodation {{hspt.huis_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmHspt">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

// import {bus} from "../../../main";

export default {
  data() { 
    return {
      dialog: false,
      hspt_encrid: null,
      hspt: {}
    }
  },
  methods: {
    open(hspt_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hspt/getHspt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHspt"
          },
          getHspt: {
            hspt_encrid: hspt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hspt = res.data.getHspt;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmHspt() { 
      this.$axios
        .post("ares/json/ares/huis/hspt/rmHspt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHspt"
          },
          rmHspt: {
            hspt_encrid: this.hspt.hspt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmHspt.text,
              color: res.data.rmHspt.color
            });
            this.$emit('updateData');
            this.dialog = false;
          }
        })
    },
  }
}
</script>

